
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ProfessionalBackground,
} from '../models';
import {
    ProfessionalBackgroundFromJSON,
    ProfessionalBackgroundToJSON,
} from '../models';

/**
 * 
 */
export class ProfileQualificationProfessionalBackgroundApi extends runtime.BaseAPI {

    /**
     * Returns all of the professional backgrounds for the profile qualification
          */
    async getAllRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ProfessionalBackground>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ProfessionalBackground>>({
            path: `/profile/api/professional-background`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ProfessionalBackgroundFromJSON);
        return response;
    }

    /**
     * Returns all of the professional backgrounds for the profile qualification
          */
    async getAll(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ProfessionalBackground>> {
        const response = await this.getAllRaw(initOverrides);
        return response._data;
    }

}
